import React, { useEffect, useState, useRef } from "react";
import { ContextProviderComponent } from "./Context.js";
import GlobalStyle from "styles/globalStyles.js";

import Footer from "components/global/footer/Footer.js";
import Nav from "components/global/nav/Nav.js";
const Index = ({ data, children, pageContext }) => {
  return (
    <main>
      <ContextProviderComponent>
        <GlobalStyle />
        <Nav />
        {children}
        <Footer />
      </ContextProviderComponent>
    </main>
  );
};

export default Index;

export const Head = () => <></>;
